import store from 'utils/store/withMiddleware'

function updateAnswers(e) {
  const target = e.target
  const state = store.getState()

  state.answersPivot[e.target.name] = +target.value
  store.update({
    answersPivot: state.answersPivot
  })
}

export default updateAnswers
